{
    "coordinates": [
        43.894914606183875,
        5.145001863157773
    ],
    "tooltip": "Cabrières",
    "title": "Cabrières Biota",
    "country": "France",
    "period": "Ordovician"
}
